export default "__VITE_ASSET__3ee3a6ba__"